import { Button, Modal } from 'antd';
import React, { useState } from 'react';

const ConfirmationModalGuarantor = ({ open, close, onYesClick, value,index }) => {
    return (
        <Modal open={open}
            centered
            onCancel={close}

            footer={[
                <Button key="submit" onClick={() => {
                    localStorage.setItem('guarantor_type_'+index, value);
                    localStorage.removeItem('guarantor_personal_details_'+index);
                    localStorage.removeItem('guarantor_details_'+index);
                    localStorage.removeItem('guarantor_employement_details_'+index);
                    localStorage.removeItem('guarantor_documents_'+index);
                    onYesClick();
                    close();
                }} type="primary">
                    Yes
                </Button>,
                <Button key="back" onClick={close}>
                    No
                </Button>,
            ]} title="Confirmation">
            <p>If you switch Guarantor type, if you have any existing Guarantor Data it will be cleared. Do you wish to continue? </p>
        </Modal>
    );
};

export default ConfirmationModalGuarantor;